const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

const ROOMS_BASE = `${API_BASE_URL}/rooms`;

export async function getRoomByCode(code) {
  const res = await fetch(`${ROOMS_BASE}/${code.toUpperCase()}`);
  if (!res.ok) throw new Error(`Room not found (${res.status})`);
  return res.json();
}

export async function submitScore({ code, matchId, submittedBy, score1, score2, scorerCode }) {
  const payload = { matchId, submittedBy, score1, score2 };
  if (scorerCode) payload.scorerCode = scorerCode;
  const res = await fetch(`${ROOMS_BASE}/${code.toUpperCase()}/scores`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (res.status === 403) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.message || 'Access denied');
    err.status = 403;
    throw err;
  }
  if (!res.ok) throw new Error(`Failed to submit score (${res.status})`);
  return res.json();
}
